import * as __d3ett from "./D3ETemplateTypes";
import GlobalFunctions from "../utils/GlobalFunctions";
import PhoneNumber from "../models/PhoneNumber";
import LoginUserType from "../classes/LoginUserType";
import SearchRequests from "../classes/SearchRequests";
import ResultStatus from "../classes/ResultStatus";
import NotificationType from "../classes/NotificationType";
import AdminListsRequest from "../models/AdminListsRequest";
import InvoiceConfiguration from "../models/InvoiceConfiguration";
import RequestsByInvoiceRequest from "../models/RequestsByInvoiceRequest";
import UserType from "../classes/UserType";
import Notifications from "../classes/Notifications";
import PaymentStatus from "../classes/PaymentStatus";
import AdministratorType from "../classes/AdministratorType";
import ActivityTrackers from "../classes/ActivityTrackers";
import ActivityTrackersRequest from "../models/ActivityTrackersRequest";
import RequestsByInvoice from "../classes/RequestsByInvoice";
import NotificationsRequest from "../models/NotificationsRequest";
import GradientType from "../classes/GradientType";
import Relative from "../models/Relative";
import LoginResult from "../classes/LoginResult";
import Administrator from "../models/Administrator";
import Invoice from "../models/Invoice";
import ConnectionStatus from "../classes/ConnectionStatus";
import HosiptalList from "../classes/HosiptalList";
import InvoicesRequest from "../models/InvoicesRequest";
import HospitalsRequest from "../models/HospitalsRequest";
import OneTimePassword from "../models/OneTimePassword";
import ActivityTracker from "../models/ActivityTracker";
import Person from "../models/Person";
import ChangePasswordRequest from "../models/ChangePasswordRequest";
import RequestStatus from "../classes/RequestStatus";
import NOKUser from "../models/NOKUser";
import Hospitals from "../classes/Hospitals";
import SearchRequestsRequest from "../models/SearchRequestsRequest";
import UsersList from "../classes/UsersList";
import ImageFrom from "../classes/ImageFrom";
import Notification from "../models/Notification";
import UsersListRequest from "../models/UsersListRequest";
import InputFieldType from "../classes/InputFieldType";
import SearchRequest from "../models/SearchRequest";
import AdminLists from "../classes/AdminLists";
import ActivityType from "../classes/ActivityType";
import Hospital from "../models/Hospital";
import Invoices from "../classes/Invoices";
import IconType from "../classes/IconType";
import HospitalStatus from "../classes/HospitalStatus";

export const ACTIVITYTRACKER: number = 0;

export const ACTIVITYTRACKERS: number = 1;

export const ACTIVITYTRACKERSREQUEST: number = 2;

export const ACTIVITYTYPE: number = 3;

export const ADMINLISTS: number = 4;

export const ADMINLISTSREQUEST: number = 5;

export const ADMINISTRATOR: number = 6;

export const ADMINISTRATORTYPE: number = 7;

export const BASEUSER: number = 8;

export const BLOB: number = 9;

export const BOOLEAN: number = 10;

export const CHANGEPASSWORDREQUEST: number = 11;

export const CONNECTIONSTATUS: number = 12;

export const DFILE: number = 13;

export const DATE: number = 14;

export const DATETIME: number = 15;

export const DOUBLE: number = 16;

export const DURATION: number = 17;

export const GRADIENTTYPE: number = 18;

export const HOSIPTALLIST: number = 19;

export const HOSPITAL: number = 20;

export const HOSPITALSTATUS: number = 21;

export const HOSPITALS: number = 22;

export const HOSPITALSREQUEST: number = 23;

export const ICONTYPE: number = 24;

export const IMAGEFROM: number = 25;

export const INPUTFIELDTYPE: number = 26;

export const INTEGER: number = 27;

export const INVOICE: number = 28;

export const INVOICECONFIGURATION: number = 29;

export const INVOICES: number = 30;

export const INVOICESREQUEST: number = 31;

export const LOGINRESULT: number = 32;

export const LOGINUSERTYPE: number = 33;

export const NOKUSER: number = 34;

export const NOTIFICATION: number = 35;

export const NOTIFICATIONTYPE: number = 36;

export const NOTIFICATIONS: number = 37;

export const NOTIFICATIONSREQUEST: number = 38;

export const ONETIMEPASSWORD: number = 39;

export const PAYMENTSTATUS: number = 40;

export const PERSON: number = 41;

export const PHONENUMBER: number = 42;

export const RELATIVE: number = 43;

export const REQUESTSTATUS: number = 44;

export const REQUESTSBYINVOICE: number = 45;

export const REQUESTSBYINVOICEREQUEST: number = 46;

export const RESULTSTATUS: number = 47;

export const SEARCHREQUEST: number = 48;

export const SEARCHREQUESTS: number = 49;

export const SEARCHREQUESTSREQUEST: number = 50;

export const STRING: number = 51;

export const TIME: number = 52;

export const TYPE: number = 53;

export const USERTYPE: number = 54;

export const USERSLIST: number = 55;

export const USERSLISTREQUEST: number = 56;

export const VOID: number = 57;

export class D3ETemplate {
  public static HASH: string = "af9e1d729698acf0b8e9ea26a78ae08e";
  private static _usages: Array<__d3ett.D3EUsage> = [
    new __d3ett.D3EUsage(
      "Query_currentUser_LoginScreen_eventHandlers_onInit_block",
      [
        new __d3ett.D3ETypeUsage(ADMINISTRATOR, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(INVOICECONFIGURATION, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(ADMINISTRATOR, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, []),
        ]),
        new __d3ett.D3ETypeUsage(NOKUSER, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(HOSPITAL, []),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, []),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, [
            new __d3ett.D3ETypeUsage(DFILE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(6, []),
          new __d3ett.D3EFieldUsage(7, []),
        ]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "1dc44f075cd58781c5969df7a78e5a19"
    ),
    new __d3ett.D3EUsage(
      "Query_getActivityTrackers_ActivityTrackerList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(ACTIVITYTRACKERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(ACTIVITYTRACKER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(ADMINISTRATOR, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, [
                new __d3ett.D3ETypeUsage(NOKUSER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, [
                    new __d3ett.D3ETypeUsage(HOSPITAL, []),
                  ]),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "30c1bf63038caf078fa7f7ecda913fd0"
    ),
    new __d3ett.D3EUsage(
      "Query_getAdminLists_AddOrEditUserAdminView_properties_admins_computation",
      [
        new __d3ett.D3ETypeUsage(ADMINLISTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "0cfedc9c6c463f247d6aae6d801e6dbe"
    ),
    new __d3ett.D3EUsage(
      "Query_getAdminLists_SupportUserList_properties_admins_computation",
      [
        new __d3ett.D3ETypeUsage(ADMINLISTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "386be709e5ed5797048abd5296f1a492"
    ),
    new __d3ett.D3EUsage(
      "Query_getAdminLists_UserAdminList_properties_admins_computation",
      [
        new __d3ett.D3ETypeUsage(ADMINLISTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "386be709e5ed5797048abd5296f1a492"
    ),
    new __d3ett.D3EUsage(
      "Query_getAdministratorById_SettingTab_admin_fetchData",
      [
        new __d3ett.D3ETypeUsage(ADMINISTRATOR, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(INVOICECONFIGURATION, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(ADMINISTRATOR, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, []),
        ]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "a49f62dbb76e9ba46da9cb300fef09b7"
    ),
    new __d3ett.D3EUsage(
      "Query_getHosiptalList_HospitalList_properties_hospitalss_computation",
      [
        new __d3ett.D3ETypeUsage(HOSIPTALLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "5d4785255569474eec8642cd0e6e209c"
    ),
    new __d3ett.D3EUsage(
      "Query_getHosiptalList_UserAdminList_properties_hospitals_computation",
      [
        new __d3ett.D3ETypeUsage(HOSIPTALLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "5d4785255569474eec8642cd0e6e209c"
    ),
    new __d3ett.D3EUsage(
      "Query_getHospitals_HospitalList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(HOSPITALS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "7be73fc75d44782deb5c1d5895170463"
    ),
    new __d3ett.D3EUsage(
      "Query_getHospitals_SystemAdminInvoiceList_properties_hospitals_computation",
      [
        new __d3ett.D3ETypeUsage(HOSPITALS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "7be73fc75d44782deb5c1d5895170463"
    ),
    new __d3ett.D3EUsage(
      "Query_getInvoices_SystemAdminInvoiceList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(INVOICES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(INVOICE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
              new __d3ett.D3EFieldUsage(8, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a908e0b78af40796df3509357e7b6878"
    ),
    new __d3ett.D3EUsage(
      "Query_getNOKUserById_SettingTab_user_fetchData",
      [
        new __d3ett.D3ETypeUsage(NOKUSER, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, []),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, [
            new __d3ett.D3ETypeUsage(DFILE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(6, []),
          new __d3ett.D3EFieldUsage(7, []),
        ]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "0d8976f59b2a26a7c16c54cd9b49c1d8"
    ),
    new __d3ett.D3EUsage(
      "Query_getNOKUserById_StaffRequestTab_user_fetchData",
      [
        new __d3ett.D3ETypeUsage(NOKUSER, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, []),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, [
            new __d3ett.D3ETypeUsage(DFILE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(6, []),
          new __d3ett.D3EFieldUsage(7, []),
        ]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "0d8976f59b2a26a7c16c54cd9b49c1d8"
    ),
    new __d3ett.D3EUsage(
      "Query_getNotifications_AdminHeaderView_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(NOTIFICATIONS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOTIFICATION, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "4b900793df1b74b912259ddd5683ab8a"
    ),
    new __d3ett.D3EUsage(
      "Query_getNotifications_NotificationView_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(NOTIFICATIONS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOTIFICATION, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "4b900793df1b74b912259ddd5683ab8a"
    ),
    new __d3ett.D3EUsage(
      "Query_getRequestsByInvoice_BillingDetailsView_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(REQUESTSBYINVOICE, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a6f1bb8ffb21f3d4ddcbcad820301874"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequestById_SearchRequestResponseView_obj_fetchData",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(NOKUSER, []),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(4, []),
          new __d3ett.D3EFieldUsage(5, []),
          new __d3ett.D3EFieldUsage(6, []),
          new __d3ett.D3EFieldUsage(7, [
            new __d3ett.D3ETypeUsage(HOSPITAL, []),
          ]),
          new __d3ett.D3EFieldUsage(8, [new __d3ett.D3ETypeUsage(INVOICE, [])]),
          new __d3ett.D3EFieldUsage(9, []),
          new __d3ett.D3EFieldUsage(10, []),
          new __d3ett.D3EFieldUsage(11, []),
          new __d3ett.D3EFieldUsage(12, []),
          new __d3ett.D3EFieldUsage(13, []),
          new __d3ett.D3EFieldUsage(14, []),
          new __d3ett.D3EFieldUsage(15, [
            new __d3ett.D3ETypeUsage(NOTIFICATION, []),
          ]),
          new __d3ett.D3EFieldUsage(16, []),
          new __d3ett.D3EFieldUsage(17, [
            new __d3ett.D3ETypeUsage(PERSON, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(PHONENUMBER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(4, [
                new __d3ett.D3ETypeUsage(RELATIVE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
              ]),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(18, []),
          new __d3ett.D3EFieldUsage(19, []),
          new __d3ett.D3EFieldUsage(20, []),
          new __d3ett.D3EFieldUsage(21, []),
          new __d3ett.D3EFieldUsage(22, []),
          new __d3ett.D3EFieldUsage(23, []),
        ]),
      ],
      "28dff62190868ae81fec4073b685a40f"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_AddOrEditInvoiceView_properties_services_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, [
                    new __d3ett.D3ETypeUsage(HOSPITAL, []),
                  ]),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(17, [
                new __d3ett.D3ETypeUsage(PERSON, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(RELATIVE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(PHONENUMBER, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(6, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ebce294bef5694f0c12e3bb2f6f8a9f4"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_CompletedRequestsView_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "f8fcfb30c0db90c655a30e016000c001"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_PendingRequestsView_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(17, [
                new __d3ett.D3ETypeUsage(PERSON, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(RELATIVE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(PHONENUMBER, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(6, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "bac5048fdf91000b0634babfcaa2012e"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_StaffRequestTab_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "f8fcfb30c0db90c655a30e016000c001"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_SystemAdminInvoiceList_properties_services_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, [
                    new __d3ett.D3ETypeUsage(HOSPITAL, []),
                  ]),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(17, [
                new __d3ett.D3ETypeUsage(PERSON, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(RELATIVE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(PHONENUMBER, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(6, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ebce294bef5694f0c12e3bb2f6f8a9f4"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_SystemAdminRequestList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, [
                    new __d3ett.D3ETypeUsage(HOSPITAL, []),
                  ]),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(17, [
                new __d3ett.D3ETypeUsage(PERSON, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(RELATIVE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(PHONENUMBER, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(6, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ebce294bef5694f0c12e3bb2f6f8a9f4"
    ),
    new __d3ett.D3EUsage(
      "Query_getSearchRequests_SystemAdminRequestList_properties_services_computation",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "f8fcfb30c0db90c655a30e016000c001"
    ),
    new __d3ett.D3EUsage(
      "Query_getUsersList_StaffPage_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Query_getUsersList_StaffPage_properties_userList_computation",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Query_getUsersList_SupportUserList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Query_getUsersList_UserAdminList_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Query_loginAdministratorUserWithEmailAndPassword_LoginScreen_eventHandlers_authenticatingUser_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(ADMINISTRATOR, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(INVOICECONFIGURATION, [
                  new __d3ett.D3EFieldUsage(0, [
                    new __d3ett.D3ETypeUsage(ADMINISTRATOR, []),
                    new __d3ett.D3ETypeUsage(BASEUSER, []),
                  ]),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, []),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "b1c525cad40e6969468d1c02812fed78"
    ),
    new __d3ett.D3EUsage(
      "Query_loginNOKUserUserWithEmailAndPassword_LoginScreen_eventHandlers_authenticatingUser_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(ADMINISTRATOR, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "85a09387a2a2b49927bc68b20db3ee9f"
    ),
    new __d3ett.D3EUsage(
      "Query_loginWithOTP_ForgotPasswordPage_eventHandlers_verifyOTP_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(ADMINISTRATOR, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "85a09387a2a2b49927bc68b20db3ee9f"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onHospitalsChange_HospitalList_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(HOSPITALS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(HOSPITAL, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "7be73fc75d44782deb5c1d5895170463"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onInvoicesChange_SystemAdminInvoiceList_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(INVOICES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(INVOICE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
              new __d3ett.D3EFieldUsage(8, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a908e0b78af40796df3509357e7b6878"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onNotificationsChange_AdminHeaderView_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(NOTIFICATIONS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOTIFICATION, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "4b900793df1b74b912259ddd5683ab8a"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onNotificationsChange_NotificationView_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(NOTIFICATIONS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOTIFICATION, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "4b900793df1b74b912259ddd5683ab8a"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onRequestsByInvoiceChange_BillingDetailsView_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(REQUESTSBYINVOICE, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a6f1bb8ffb21f3d4ddcbcad820301874"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onSearchRequestsChange_StaffRequestTab_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "f8fcfb30c0db90c655a30e016000c001"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onSearchRequestsChange_SystemAdminRequestList_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(SEARCHREQUESTS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(SEARCHREQUEST, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(NOKUSER, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, [
                    new __d3ett.D3ETypeUsage(HOSPITAL, []),
                  ]),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(6, []),
                  new __d3ett.D3EFieldUsage(7, []),
                ]),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, [
                new __d3ett.D3ETypeUsage(HOSPITAL, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(8, [
                new __d3ett.D3ETypeUsage(INVOICE, []),
              ]),
              new __d3ett.D3EFieldUsage(9, []),
              new __d3ett.D3EFieldUsage(10, []),
              new __d3ett.D3EFieldUsage(11, []),
              new __d3ett.D3EFieldUsage(12, []),
              new __d3ett.D3EFieldUsage(13, []),
              new __d3ett.D3EFieldUsage(14, []),
              new __d3ett.D3EFieldUsage(15, [
                new __d3ett.D3ETypeUsage(NOTIFICATION, []),
              ]),
              new __d3ett.D3EFieldUsage(16, []),
              new __d3ett.D3EFieldUsage(17, [
                new __d3ett.D3ETypeUsage(PERSON, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(PHONENUMBER, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(RELATIVE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(PHONENUMBER, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(6, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, [
                    new __d3ett.D3ETypeUsage(SEARCHREQUEST, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(18, []),
              new __d3ett.D3EFieldUsage(19, []),
              new __d3ett.D3EFieldUsage(20, []),
              new __d3ett.D3EFieldUsage(21, []),
              new __d3ett.D3EFieldUsage(22, []),
              new __d3ett.D3EFieldUsage(23, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ebce294bef5694f0c12e3bb2f6f8a9f4"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onUsersListChange_StaffPage_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onUsersListChange_SupportUserList_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onUsersListChange_UserAdminList_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(USERSLIST, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(NOKUSER, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, [
                new __d3ett.D3ETypeUsage(HOSPITAL, []),
              ]),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(6, []),
              new __d3ett.D3EFieldUsage(7, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "ea1ff8d6f7e18779da4dfb6fa8ec782c"
    ),
  ];
  private static _types: Array<__d3ett.D3ETemplateType> = [
    new __d3ett.D3ETemplateType(
      "ActivityTracker",
      "52f6febf6afa1d5b6bbc8c8c21777d1e",
      [
        new __d3ett.D3ETemplateField(
          "activityType",
          ACTIVITYTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "administrator",
          ADMINISTRATOR,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "createDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "description",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "user",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "userType",
          LOGINUSERTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new ActivityTracker(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ActivityTrackers",
      "8ef19fbb4c4d51ddde7b48f3c9b26323",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          ACTIVITYTRACKER,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new ActivityTrackers(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ActivityTrackersRequest",
      "d0be82f1c5846f5bc4cf8e062a703826",
      [
        new __d3ett.D3ETemplateField(
          "activityType",
          ACTIVITYTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "applyActivityType",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "user",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new ActivityTrackersRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ActivityType",
      "d2649768d24db4c6b7cd4ff62fb785c7",
      [
        new __d3ett.D3ETemplateField("Login", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Payment", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Request", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Others", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "AdminLists",
      "f8434bd45403551e0012536af1925cd4",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new AdminLists(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "AdminListsRequest",
      "7429dae40e5aa4c847e6b7d91b43ff5d",
      [
        new __d3ett.D3ETemplateField(
          "userType",
          USERTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new AdminListsRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Administrator",
      "9fbeeca8ef9d556b90787f19cd4c3644",
      [
        new __d3ett.D3ETemplateField(
          "administratorType",
          ADMINISTRATORTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoiceConfiguration",
          INVOICECONFIGURATION,
          __d3ett.D3EFieldType.Ref,
          { "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "mobileNumber",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "password",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "parent": 8,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Administrator(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "AdministratorType",
      "c355e069ff5236dfc527ea77f78b64ca",
      [
        new __d3ett.D3ETemplateField("Admin", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Employee", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "BaseUser",
      "5116c054754a25edc5a13eddbd47e85a",
      [],
      { "abstract": true, "refType": __d3ett.D3ERefType.Model }
    ),
    new __d3ett.D3ETemplateType(
      "Blob",
      "e8016c85ada38bdc5fac616ec1318047",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Boolean",
      "27226c864bac7454a8504f8edb15d95b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "ChangePasswordRequest",
      "7bd88617205355840f720948d2b93298",
      [
        new __d3ett.D3ETemplateField(
          "newPassword",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new ChangePasswordRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ConnectionStatus",
      "0d5c2bfbc6b6e414981c0c67321165d5",
      [
        new __d3ett.D3ETemplateField(
          "Connecting",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Connected", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "ConnectionBusy",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionNormal",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RestoreFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "AuthFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "DFile",
      "71a781845a8ebe8adf67352a573af199",
      [
        new __d3ett.D3ETemplateField("id", STRING, __d3ett.D3EFieldType.String),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "size",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "mimeType",
          STRING,
          __d3ett.D3EFieldType.String
        ),
      ],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Date",
      "44749712dbec183e983dcd78a7736c41",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "DateTime",
      "8cf10d2341ed01492506085688270c1e",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Double",
      "d909d38d705ce75386dd86e611a82f5b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Duration",
      "e02d2ae03de9d493df2b6b2d2813d302",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "GradientType",
      "dfc80f7e140e2dac94987925914062a8",
      [
        new __d3ett.D3ETemplateField("Color", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "LinearGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "SweepGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RadialGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "HosiptalList",
      "9bcc612706f5c8d97342756325f9cc89",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new HosiptalList(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Hospital",
      "6e950ac15b7111acdf247d9be5a795e3",
      [
        new __d3ett.D3ETemplateField(
          "address",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          HOSPITALSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Hospital() }
    ),
    new __d3ett.D3ETemplateType(
      "HospitalStatus",
      "4a058819b0dc63fdc761f5504bab0c61",
      [
        new __d3ett.D3ETemplateField("Inactive", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Active", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Suspened", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Hospitals",
      "0e9734dad51c697531243b189ba2c1c5",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Struct, "creator": () => new Hospitals() }
    ),
    new __d3ett.D3ETemplateType(
      "HospitalsRequest",
      "de8306cff55ea607c575400fdb5fce52",
      [
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          HOSPITALSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new HospitalsRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "IconType",
      "4529ef025543fdd73b83290b6c7b541f",
      [
        new __d3ett.D3ETemplateField("SVG", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Font", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "ImageFrom",
      "7462b5b42617aa6ada4b99b737535133",
      [
        new __d3ett.D3ETemplateField("Network", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Asset", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Project", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "InputFieldType",
      "568d09fd20b1f156d646d0308f64e3b6",
      [
        new __d3ett.D3ETemplateField("Rectangle", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Circle", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Underline", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("None", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Integer",
      "a0faef0851b4294c06f2b94bb1cb2044",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Invoice",
      "c6401f466bd6ad691ae3d77482260b4e",
      [
        new __d3ett.D3ETemplateField(
          "amount",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "dueDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoiceDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoiceId",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoiceMonth",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "requestCount",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          PAYMENTSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Invoice() }
    ),
    new __d3ett.D3ETemplateType(
      "InvoiceConfiguration",
      "4aef1042214119bea0906b4d26eef448",
      [
        new __d3ett.D3ETemplateField(
          "administrator",
          ADMINISTRATOR,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "basePrice",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "day",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "discount",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "lateFee",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "minimumPrice",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pricePerAdvancedRequest",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "taxation",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new InvoiceConfiguration(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Invoices",
      "bacc68335f0b293419b12a35637b0645",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          INVOICE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Struct, "creator": () => new Invoices() }
    ),
    new __d3ett.D3ETemplateType(
      "InvoicesRequest",
      "f04001b01ea1302486aa2ebe44155ea4",
      [
        new __d3ett.D3ETemplateField(
          "applyMonth",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "monthNumber",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          PAYMENTSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new InvoicesRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "LoginResult",
      "43b15c92fa28924318ec2dd9b20d65d3",
      [
        new __d3ett.D3ETemplateField(
          "failureMessage",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "success",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean
        ),
        new __d3ett.D3ETemplateField(
          "token",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "userObject",
          BASEUSER,
          __d3ett.D3EFieldType.Ref
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new LoginResult(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "LoginUserType",
      "e2ca2a8fc3b4423526eac5574ceefe62",
      [
        new __d3ett.D3ETemplateField(
          "Administrator",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Admin", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Staff", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "NOKUser",
      "03536a1f1c63d3c0437129e1a400486f",
      [
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "mobile",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "password",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "profile",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "userType",
          USERTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "parent": 8,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new NOKUser(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Notification",
      "aaf977d607507d5bb2a36866cd0609c2",
      [
        new __d3ett.D3ETemplateField(
          "createdAt",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "description",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "request",
          SEARCHREQUEST,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "type",
          NOTIFICATIONTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "user",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "viewed",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Notification(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "NotificationType",
      "8ac5826b800e9fdc5a48eee7680e93b8",
      [
        new __d3ett.D3ETemplateField(
          "ServiceType",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "InvoiceType",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Notifications",
      "bd5fafc3f267adec51991d0bec62e71d",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          NOTIFICATION,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new Notifications(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "NotificationsRequest",
      "b01a1d1bc2c70c7d51490692c4f63503",
      [
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          NOTIFICATIONTYPE,
          __d3ett.D3EFieldType.Enum,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "user",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new NotificationsRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "OneTimePassword",
      "51ff4b4311b22fe068e4103b21e0b0b8",
      [
        new __d3ett.D3ETemplateField(
          "input",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "inputType",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "token",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "userType",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new OneTimePassword(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "PaymentStatus",
      "635dfc6d946bde992fad7b0b8fa007f4",
      [
        new __d3ett.D3ETemplateField("Unpaid", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Paid", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Fail", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Person",
      "1735ff7c865b30c971472ff6c34318bd",
      [
        new __d3ett.D3ETemplateField(
          "dateOfBirth",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "emails",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "fullName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "phoneNumbers",
          PHONENUMBER,
          __d3ett.D3EFieldType.Ref,
          { "child": true, "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "relatives",
          RELATIVE,
          __d3ett.D3EFieldType.Ref,
          { "child": true, "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "searchRequest",
          SEARCHREQUEST,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Person() }
    ),
    new __d3ett.D3ETemplateType(
      "PhoneNumber",
      "5c96e353697bb84e93d63baaeddbcbc6",
      [
        new __d3ett.D3ETemplateField(
          "location",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "phoneNumber",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "phoneType",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new PhoneNumber(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Relative",
      "b748698fdb781b6112862eac594e9d95",
      [
        new __d3ett.D3ETemplateField(
          "dob",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "emails",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "firstName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "lastName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "middleName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "phoneNumbers",
          PHONENUMBER,
          __d3ett.D3EFieldType.Ref,
          { "child": true, "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "relation",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Relative() }
    ),
    new __d3ett.D3ETemplateType(
      "RequestStatus",
      "e64ab3364b91b0989a0cc0d7abfff095",
      [
        new __d3ett.D3ETemplateField(
          "Processing",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Resolved", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Failed", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "RequestsByInvoice",
      "eda198de59ae33472c7a4b15ce1decdf",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          SEARCHREQUEST,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new RequestsByInvoice(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "RequestsByInvoiceRequest",
      "f040b98241b5375eddf34d7b2c672a70",
      [
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoice",
          INVOICE,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new RequestsByInvoiceRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ResultStatus",
      "b3e4a20b998b614cb3f7bd669946ae7f",
      [
        new __d3ett.D3ETemplateField("Success", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Errors", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "SearchRequest",
      "23d3fa26ca3d598813518226e21925e3",
      [
        new __d3ett.D3ETemplateField(
          "addressLine1",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "addressLine2",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "city",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "createdBy",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "dateOfBirth",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "failedMessage",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "firstName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "invoice",
          INVOICE,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "isAdvancedSearch",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "isBilled",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "lastName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "middleName",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "mobile",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "notes",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "notification",
          NOTIFICATION,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "requestDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "response",
          PERSON,
          __d3ett.D3EFieldType.Ref,
          { "collection": true, "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "sSN",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "searchId",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "state",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          REQUESTSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "tahoeId",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "zip",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new SearchRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "SearchRequests",
      "edcba75e60aa14c074af529a64904c67",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          SEARCHREQUEST,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new SearchRequests(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "SearchRequestsRequest",
      "ea6e3fb444b30770ae320b07cde2f265",
      [
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "createdBy",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "fromDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "request",
          SEARCHREQUEST,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          REQUESTSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "toDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new SearchRequestsRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "String",
      "27118326006d3829667a400ad23d5d98",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Time",
      "a76d4ef5f3f6a672bbfab2865563e530",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Type",
      "a1fa27779242b4902f7ae3bdd5c6d508",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "UserType",
      "ff7c6fe6adbb9b9c0180a1bc5588ecf4",
      [
        new __d3ett.D3ETemplateField("Admin", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Staff", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "UsersList",
      "25237c3eef1dc10312baff971a5b35e9",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Struct, "creator": () => new UsersList() }
    ),
    new __d3ett.D3ETemplateType(
      "UsersListRequest",
      "f2f7c7709abfd5b2b764f48eb21fda63",
      [
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "hospital",
          HOSPITAL,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "user",
          NOKUSER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "userType",
          USERTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new UsersListRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "void",
      "cab8111fd0b710a336c898e539090e34",
      [],
      {}
    ),
  ];
  private static readonly _typeMap: Map<string, number> = Map.fromIterables(
    D3ETemplate._types.map((x) => x.name),
    Array.generate(D3ETemplate._types.length, (index) => index)
  );
  public static allFields(type: number): Array<number> {
    return Array.generate(
      D3ETemplate._types[type].fields.length,
      (index) => index
    );
  }
  public static get types(): Array<__d3ett.D3ETemplateType> {
    return D3ETemplate._types;
  }
  public static get usages(): Array<__d3ett.D3EUsage> {
    return D3ETemplate._usages;
  }
  public static typeString(val: number): string {
    return D3ETemplate._types[val].name;
  }
  public static typeInt(val: string): number {
    return D3ETemplate._typeMap.get(val);
  }
  public static _getField(type: number, val: number): __d3ett.D3ETemplateField {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    /*
_type will have fields with index starting from _type.parentFields.
Anything less needs to be looked up in _type.parent.
*/

    if (val < _type.parentFields) {
      return D3ETemplate._getField(_type.parent, val);
    }

    /*
The field cannot be in _type's child, so subtract _type.parentField from val, and use that as index.
*/

    let adjustedIndex: number = val - _type.parentFields;

    return _type.fields[adjustedIndex];
  }
  public static fieldString(type: number, val: number): string {
    return D3ETemplate._getField(type, val).name;
  }
  public static fieldType(type: number, val: number): number {
    return D3ETemplate._getField(type, val).type;
  }
  public static isChild(type: number, val: number): boolean {
    return D3ETemplate._getField(type, val).child;
  }
  public static fieldInt(type: number, val: string): number {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    if (_type.fieldMap.containsKey(val)) {
      return _type.fieldMap[val];
    }

    if (_type.parent != null) {
      return D3ETemplate.fieldInt(_type.parent, val);
    }

    return null;
  }
  public static isEmbedded(type: number): boolean {
    return D3ETemplate._types[type].embedded;
  }
  public static isAbstract(type: number): boolean {
    return D3ETemplate._types[type].abstract;
  }
  public static hasParent(type: number): boolean {
    return D3ETemplate._types[type].parent != null;
  }
  public static parent(type: number): number {
    return D3ETemplate._types[type].parent;
  }
  public static getEnumField<T>(type: number, field: number): T {
    switch (type) {
      case ACTIVITYTYPE: {
        return ActivityType.values[field] as unknown as T;
      }

      case ADMINISTRATORTYPE: {
        return AdministratorType.values[field] as unknown as T;
      }

      case CONNECTIONSTATUS: {
        return ConnectionStatus.values[field] as unknown as T;
      }

      case GRADIENTTYPE: {
        return GradientType.values[field] as unknown as T;
      }

      case HOSPITALSTATUS: {
        return HospitalStatus.values[field] as unknown as T;
      }

      case ICONTYPE: {
        return IconType.values[field] as unknown as T;
      }

      case IMAGEFROM: {
        return ImageFrom.values[field] as unknown as T;
      }

      case INPUTFIELDTYPE: {
        return InputFieldType.values[field] as unknown as T;
      }

      case LOGINUSERTYPE: {
        return LoginUserType.values[field] as unknown as T;
      }

      case NOTIFICATIONTYPE: {
        return NotificationType.values[field] as unknown as T;
      }

      case PAYMENTSTATUS: {
        return PaymentStatus.values[field] as unknown as T;
      }

      case REQUESTSTATUS: {
        return RequestStatus.values[field] as unknown as T;
      }

      case RESULTSTATUS: {
        return ResultStatus.values[field] as unknown as T;
      }

      case USERTYPE: {
        return UserType.values[field] as unknown as T;
      }
    }
  }
}

export class UsageConstants {
  public static readonly QUERY_CURRENTUSER_LOGINSCREEN_EVENTHANDLERS_ONINIT_BLOCK: number = 0;
  public static readonly QUERY_GETACTIVITYTRACKERS_ACTIVITYTRACKERLIST_PROPERTIES_QUERY_COMPUTATION: number = 1;
  public static readonly QUERY_GETADMINLISTS_ADDOREDITUSERADMINVIEW_PROPERTIES_ADMINS_COMPUTATION: number = 2;
  public static readonly QUERY_GETADMINLISTS_SUPPORTUSERLIST_PROPERTIES_ADMINS_COMPUTATION: number = 3;
  public static readonly QUERY_GETADMINLISTS_USERADMINLIST_PROPERTIES_ADMINS_COMPUTATION: number = 4;
  public static readonly QUERY_GETADMINISTRATORBYID_SETTINGTAB_ADMIN_FETCHDATA: number = 5;
  public static readonly QUERY_GETHOSIPTALLIST_HOSPITALLIST_PROPERTIES_HOSPITALSS_COMPUTATION: number = 6;
  public static readonly QUERY_GETHOSIPTALLIST_USERADMINLIST_PROPERTIES_HOSPITALS_COMPUTATION: number = 7;
  public static readonly QUERY_GETHOSPITALS_HOSPITALLIST_PROPERTIES_QUERY_COMPUTATION: number = 8;
  public static readonly QUERY_GETHOSPITALS_SYSTEMADMININVOICELIST_PROPERTIES_HOSPITALS_COMPUTATION: number = 9;
  public static readonly QUERY_GETINVOICES_SYSTEMADMININVOICELIST_PROPERTIES_QUERY_COMPUTATION: number = 10;
  public static readonly QUERY_GETNOKUSERBYID_SETTINGTAB_USER_FETCHDATA: number = 11;
  public static readonly QUERY_GETNOKUSERBYID_STAFFREQUESTTAB_USER_FETCHDATA: number = 12;
  public static readonly QUERY_GETNOTIFICATIONS_ADMINHEADERVIEW_PROPERTIES_QUERY_COMPUTATION: number = 13;
  public static readonly QUERY_GETNOTIFICATIONS_NOTIFICATIONVIEW_PROPERTIES_QUERY_COMPUTATION: number = 14;
  public static readonly QUERY_GETREQUESTSBYINVOICE_BILLINGDETAILSVIEW_PROPERTIES_QUERY_COMPUTATION: number = 15;
  public static readonly QUERY_GETSEARCHREQUESTBYID_SEARCHREQUESTRESPONSEVIEW_OBJ_FETCHDATA: number = 16;
  public static readonly QUERY_GETSEARCHREQUESTS_ADDOREDITINVOICEVIEW_PROPERTIES_SERVICES_COMPUTATION: number = 17;
  public static readonly QUERY_GETSEARCHREQUESTS_COMPLETEDREQUESTSVIEW_PROPERTIES_QUERY_COMPUTATION: number = 18;
  public static readonly QUERY_GETSEARCHREQUESTS_PENDINGREQUESTSVIEW_PROPERTIES_QUERY_COMPUTATION: number = 19;
  public static readonly QUERY_GETSEARCHREQUESTS_STAFFREQUESTTAB_PROPERTIES_QUERY_COMPUTATION: number = 20;
  public static readonly QUERY_GETSEARCHREQUESTS_SYSTEMADMININVOICELIST_PROPERTIES_SERVICES_COMPUTATION: number = 21;
  public static readonly QUERY_GETSEARCHREQUESTS_SYSTEMADMINREQUESTLIST_PROPERTIES_QUERY_COMPUTATION: number = 22;
  public static readonly QUERY_GETSEARCHREQUESTS_SYSTEMADMINREQUESTLIST_PROPERTIES_SERVICES_COMPUTATION: number = 23;
  public static readonly QUERY_GETUSERSLIST_STAFFPAGE_PROPERTIES_QUERY_COMPUTATION: number = 24;
  public static readonly QUERY_GETUSERSLIST_STAFFPAGE_PROPERTIES_USERLIST_COMPUTATION: number = 25;
  public static readonly QUERY_GETUSERSLIST_SUPPORTUSERLIST_PROPERTIES_QUERY_COMPUTATION: number = 26;
  public static readonly QUERY_GETUSERSLIST_USERADMINLIST_PROPERTIES_QUERY_COMPUTATION: number = 27;
  public static readonly QUERY_LOGINADMINISTRATORUSERWITHEMAILANDPASSWORD_LOGINSCREEN_EVENTHANDLERS_AUTHENTICATINGUSER_BLOCK: number = 28;
  public static readonly QUERY_LOGINNOKUSERUSERWITHEMAILANDPASSWORD_LOGINSCREEN_EVENTHANDLERS_AUTHENTICATINGUSER_BLOCK: number = 29;
  public static readonly QUERY_LOGINWITHOTP_FORGOTPASSWORDPAGE_EVENTHANDLERS_VERIFYOTP_BLOCK: number = 30;
  public static readonly SUBSCRIPTION_ONHOSPITALSCHANGE_HOSPITALLIST_QUERY_SYNCHRONISE: number = 31;
  public static readonly SUBSCRIPTION_ONINVOICESCHANGE_SYSTEMADMININVOICELIST_QUERY_SYNCHRONISE: number = 32;
  public static readonly SUBSCRIPTION_ONNOTIFICATIONSCHANGE_ADMINHEADERVIEW_QUERY_SYNCHRONISE: number = 33;
  public static readonly SUBSCRIPTION_ONNOTIFICATIONSCHANGE_NOTIFICATIONVIEW_QUERY_SYNCHRONISE: number = 34;
  public static readonly SUBSCRIPTION_ONREQUESTSBYINVOICECHANGE_BILLINGDETAILSVIEW_QUERY_SYNCHRONISE: number = 35;
  public static readonly SUBSCRIPTION_ONSEARCHREQUESTSCHANGE_STAFFREQUESTTAB_QUERY_SYNCHRONISE: number = 36;
  public static readonly SUBSCRIPTION_ONSEARCHREQUESTSCHANGE_SYSTEMADMINREQUESTLIST_QUERY_SYNCHRONISE: number = 37;
  public static readonly SUBSCRIPTION_ONUSERSLISTCHANGE_STAFFPAGE_QUERY_SYNCHRONISE: number = 38;
  public static readonly SUBSCRIPTION_ONUSERSLISTCHANGE_SUPPORTUSERLIST_QUERY_SYNCHRONISE: number = 39;
  public static readonly SUBSCRIPTION_ONUSERSLISTCHANGE_USERADMINLIST_QUERY_SYNCHRONISE: number = 40;
}

export class ChannelConstants {
  public static readonly TOTAL_CHANNEL_COUNT: number = 0;
  public static readonly channels: Array<__d3ett.D3ETemplateClass> = [];
}

export class RPCConstants {
  public static readonly UniqueChecker: number = 0;
  public static readonly UniqueCheckerCheckTokenUniqueInOneTimePassword: number = 0;
  public static readonly UniqueCheckerCheckEmailUniqueInAdministrator: number = 1;
  public static readonly UniqueCheckerCheckNameUniqueInHospital: number = 2;
  public static readonly UniqueCheckerCheckInvoiceInvoiceIdUniqueInHospital: number = 3;
  public static readonly UniqueCheckerCheckNOKUserEmailUniqueInHospital: number = 4;
  public static readonly UniqueCheckerCheckSearchRequestSearchIdUniqueInHospital: number = 5;
  public static readonly UNIQUECHECKER_PROCEDURE_COUNT: number = 6;
  public static readonly FileService: number = 1;
  public static readonly FILESERVICE_PROCEDURE_COUNT: number = 0;
  public static readonly ExportUtils: number = 2;
  public static readonly ExportUtilsCreateInvoice: number = 0;
  public static readonly EXPORTUTILS_PROCEDURE_COUNT: number = 1;
  public static readonly PaymentService: number = 3;
  public static readonly PaymentServiceCreateSessionLink: number = 0;
  public static readonly PAYMENTSERVICE_PROCEDURE_COUNT: number = 1;
  public static readonly TOTAL_RPC_CLASS_COUNT: number = 4;
  public static readonly classes: Array<__d3ett.D3ETemplateClass> = [
    new __d3ett.D3ETemplateClass(
      "UniqueChecker",
      "b8eefb4056c4c88268172b38e6198c00",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkTokenUniqueInOneTimePassword",
          [
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("OneTimePassword"),
              {}
            ),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkEmailUniqueInAdministrator",
          [
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("Administrator"),
              {}
            ),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkNameUniqueInHospital",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Hospital"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkInvoiceInvoiceIdUniqueInHospital",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Hospital"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Invoice"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkNOKUserEmailUniqueInHospital",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Hospital"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("NOKUser"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkSearchRequestSearchIdUniqueInHospital",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Hospital"), {}),
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("SearchRequest"),
              {}
            ),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "FileService",
      "e256e0e9ad423eb20c85f506f4580ce8",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "ExportUtils",
      "2526a40f8e0675140bc3ecd56382813c",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "createInvoice",
          [
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("RequestsByInvoiceRequest"),
              {}
            ),
          ],
          D3ETemplate.typeInt("DFile"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "PaymentService",
      "51b18c05a1644fc29c4d6e251858f782",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "createSessionLink",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Double"), {}),
          ],
          D3ETemplate.typeInt("String"),
          {}
        ),
      ]
    ),
  ];
}
GlobalFunctions.typeInt = D3ETemplate.typeInt;

GlobalFunctions.types = D3ETemplate.types;
